import React, { useState, useEffect } from 'react';
import { groupBy } from 'lodash';
import StackGrid from 'react-stack-grid';
import './App.css';

function Place(props) {
  return (
    <div style={{ width: 200 }}>
      <h3>
        <a
          href={`https://www.instagram.com/explore/locations/${
            props.value.igLocation.id
          }`}>
          {props.value.igLocation.name}
        </a>
      </h3>
      <img src={props.value.thumbnailSrc} style={{ width: 200, height: 200 }} />
      <p>{props.value.caption}</p>
    </div>
  );
}

function Places(props) {
  let isHiddenByDefault = props.country === 'France' ? false : true;
  let [hidden, setHidden] = useState(isHiddenByDefault);

  return (
    <>
      <h2 onClick={() => setHidden(!hidden)}>
        {props.country === 'undefined' ? 'Unknown' : props.country}
      </h2>

      {hidden ? null : (
        <StackGrid columnWidth={200}>
          {props.places.map(place => (
            <Place value={place} key={place.id} />
          ))}
        </StackGrid>
      )}
    </>
  );
}

function App() {
  let [places, setPlaces] = useState({});

  useEffect(() => {
    async function fetchData() {
      let response = await fetch('/data.json');
      let result = await response.json();
      let places = groupBy(result, r => r.country);
      setPlaces(places);
    }

    fetchData();
  }, []);

  return (
    <div className="App">
      <h1>hungry heimy</h1>
      <p>a totally not creepy way to browse all of the places that eric wareheim hangs out because he has the most delicious taste in food. data is drawn from instagram posts: <a href="https://www.instagram.com/ericwareheim/">@ericwareheim</a></p>
      <hr />
      {Object.keys(places).map(country => (
        <Places country={country} places={places[country]} />
      ))}
    </div>
  );
}

export default App;
